import React from 'react';
import { DataModel, ValueModel, Mode, MonthCode, CoreService, Segment, Type } from '@sbzen/cron-core';

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _superPropBase(object, property) {
  while (!Object.prototype.hasOwnProperty.call(object, property)) {
    object = _getPrototypeOf(object);
    if (object === null) break;
  }

  return object;
}

function _get(target, property, receiver) {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    _get = Reflect.get;
  } else {
    _get = function _get(target, property, receiver) {
      var base = _superPropBase(target, property);

      if (!base) return;
      var desc = Object.getOwnPropertyDescriptor(base, property);

      if (desc.get) {
        return desc.get.call(receiver);
      }

      return desc.value;
    };
  }

  return _get(target, property, receiver || target);
}

var QuartzCronService =
/*#__PURE__*/
function () {
  function QuartzCronService(coreService) {
    _classCallCheck(this, QuartzCronService);

    this.coreService = coreService;
    this.view = {
      seconds: {
        selected: Mode.AND,
        values: {
          AND: this.createValue(['0'], Mode.AND),
          RANGE: this.createValue(['0', '0'], Mode.RANGE),
          INCREMENT: this.createValue(['0', '1'], Mode.INCREMENT),
          EVERY: this.createValue(['*'], Mode.EVERY)
        }
      },
      minutes: {
        selected: Mode.AND,
        values: {
          AND: this.createValue(['0'], Mode.AND),
          RANGE: this.createValue(['0', '0'], Mode.RANGE),
          INCREMENT: this.createValue(['0', '1'], Mode.INCREMENT),
          EVERY: this.createValue(['*'], Mode.EVERY)
        }
      },
      hours: {
        selected: Mode.AND,
        values: {
          RANGE: this.createValue(['0', '0'], Mode.RANGE),
          INCREMENT: this.createValue(['0', '1'], Mode.INCREMENT),
          AND: this.createValue(['0'], Mode.AND),
          EVERY: this.createValue(['*'], Mode.EVERY)
        }
      },
      month: {
        selected: Mode.EVERY,
        values: {
          AND: this.createValue([MonthCode.JAN], Mode.AND),
          RANGE: this.createValue(['1', '1'], Mode.RANGE),
          INCREMENT: this.createValue(['1', '1'], Mode.INCREMENT),
          EVERY: this.createValue(['*'], Mode.EVERY),
          NONE: this.createValue(['*'], Mode.NONE)
        }
      },
      dayOfMonth: {
        selected: Mode.NONE,
        values: {
          AND: this.createValue(['1'], Mode.AND),
          LAST_DAY: this.createValue(['L'], Mode.LAST_DAY),
          NEAREST_WEEKDAY_OF_MONTH: this.createValue(['1W'], Mode.NEAREST_WEEKDAY_OF_MONTH),
          DAYS_BEFORE_END_MONTH: this.createValue(['L-1'], Mode.DAYS_BEFORE_END_MONTH),
          LAST_DAY_WEEK: this.createValue(['LW'], Mode.LAST_DAY_WEEK),
          RANGE: this.createValue(['0', '0'], Mode.RANGE),
          INCREMENT: this.createValue(['1', '1'], Mode.INCREMENT),
          EVERY: this.createValue(['*'], Mode.EVERY),
          NONE: this.createValue([''], Mode.NONE)
        }
      },
      dayOfWeek: {
        selected: Mode.NONE,
        values: {
          AND: this.createValue(['SUN'], Mode.AND),
          INCREMENT: this.createValue(['1', '1'], Mode.INCREMENT),
          NTH_WEEKDAY_OF_MONTH: this.createValue(['1', '1'], Mode.NTH_WEEKDAY_OF_MONTH),
          LAST_NTH_DAY_WEEK: this.createValue(['1L'], Mode.LAST_NTH_DAY_WEEK),
          NONE: this.createValue([''], Mode.NONE),
          EVERY: this.createValue(['*'], Mode.EVERY)
        }
      },
      year: {
        selected: Mode.EVERY,
        values: {
          AND: this.createValue(['2019'], Mode.AND),
          RANGE: this.createValue(['2019', '2019'], Mode.RANGE),
          INCREMENT: this.createValue(['2019', '1'], Mode.INCREMENT),
          EVERY: this.createValue(['*'], Mode.EVERY)
        }
      }
    };
  }

  _createClass(QuartzCronService, [{
    key: "setView",
    value: function setView(segment, viewItem) {
      this.view[segment] = Object.assign({}, viewItem);
    }
  }, {
    key: "getView",
    value: function getView(segment) {
      return Object.assign({}, this.view[segment]);
    }
  }, {
    key: "toString",
    value: function toString() {
      var m = this.genDataModel();
      return this.coreService.toString(m);
    }
  }, {
    key: "fillFromExpression",
    value: function fillFromExpression(cronExpression) {
      var _this = this;

      var m = this.coreService.toModel(cronExpression);
      Object.keys(m).forEach(function (prop) {
        _this.view[prop].selected = m[prop].mode;
        _this.view[prop].values[m[prop].mode] = m[prop];
        _this.view[prop] = Object.assign({}, _this.view[prop]);
      });
    }
  }, {
    key: "hasValue",
    value: function hasValue(value, type, mode) {
      var values = this.getValues(type, mode);
      return !!~values.indexOf(value);
    }
  }, {
    key: "getValues",
    value: function getValues(type, mode) {
      var store = this.view[type];
      return store.values[mode].values.concat();
    }
  }, {
    key: "genDataModel",
    value: function genDataModel() {
      var _this2 = this;

      var m = new DataModel();
      Object.keys(this.view).forEach(function (prop) {
        var i = _this2.view[prop];
        var selected = i.selected;
        var value = i.values[selected];
        value.mode = i.selected;
        m[prop] = value;
      });
      return m;
    }
  }, {
    key: "createValue",
    value: function createValue(values, mode) {
      return new ValueModel({
        values: values,
        mode: mode
      });
    }
  }]);

  return QuartzCronService;
}();

var QuartzCronDI =
/*#__PURE__*/
function () {
  function QuartzCronDI() {
    _classCallCheck(this, QuartzCronDI);
  }

  _createClass(QuartzCronDI, null, [{
    key: "get",
    value: function get(session) {
      if (!this.map.has(session)) {
        this.create(session);
      }

      return this.map.get(session);
    }
  }, {
    key: "destroy",
    value: function destroy(session) {
      this.map["delete"](session);
    }
  }, {
    key: "create",
    value: function create(session) {
      var inst = new QuartzCronService(new CoreService());
      this.map.set(session, inst);
    }
  }]);

  return QuartzCronDI;
}();
QuartzCronDI.map = new Map();

var CronBaseComponent =
/*#__PURE__*/
function (_React$Component) {
  _inherits(CronBaseComponent, _React$Component);

  function CronBaseComponent(props, session) {
    var _this;

    _classCallCheck(this, CronBaseComponent);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CronBaseComponent).call(this, props));
    _this.session = session;
    return _this;
  }

  _createClass(CronBaseComponent, [{
    key: "getCssClassPrefix",
    value: function getCssClassPrefix() {
      return this.props.cssClassPrefix || '';
    }
  }, {
    key: "genClassName",
    value: function genClassName(classes) {
      var _this2 = this;

      var noPrefixClasses = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var prefixed = classes.map(function (c) {
        return _this2.getCssClassPrefix() + c;
      });
      return prefixed.concat(noPrefixClasses).join(' ');
    }
  }, {
    key: "getQuartzCron",
    value: function getQuartzCron() {
      return QuartzCronDI.get(this.session);
    }
  }]);

  return CronBaseComponent;
}(React.Component);

var TabBaseComponent =
/*#__PURE__*/
function (_CronBaseComponent) {
  _inherits(TabBaseComponent, _CronBaseComponent);

  function TabBaseComponent(props, segments) {
    var _this;

    _classCallCheck(this, TabBaseComponent);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TabBaseComponent).call(this, props, props.session));
    _this.segments = segments;
    _this.sessionId = Date.now().toString();
    return _this;
  }

  _createClass(TabBaseComponent, [{
    key: "genId",
    value: function genId(mode, extra) {
      return "".concat(mode, "-").concat(extra).concat(this.sessionId);
    }
  }, {
    key: "inSpecificsList",
    value: function inSpecificsList(value, mode, segment) {
      return this.getQuartzCron().hasValue(value, segment, mode);
    }
  }, {
    key: "applyChanges",
    value: function applyChanges() {
      var _this2 = this;

      var newState = {};
      this.segments.forEach(function (s) {
        newState[s] = _this2.getView(s);
      });
      this.setState(_objectSpread2({}, this.state, {}, newState));
      this.props.onChange();
    }
  }, {
    key: "setInValue",
    value: function setInValue(mode, index, value, segment) {
      var view = this.getView(segment);
      var values = view.values[mode].values;
      values[index] = value;
      this.setView(segment, view);
      this.applyChanges();
    }
  }, {
    key: "isDisabled",
    value: function isDisabled(mode, segment) {
      var disabled = this.props.disabled;

      if (segment && mode) {
        var view = this.getView(segment);
        disabled = disabled || view.selected !== mode;
      }

      return disabled;
    }
  }, {
    key: "getValues",
    value: function getValues(mode, segment) {
      return this.getQuartzCron().getValues(segment, mode);
    }
  }, {
    key: "getView",
    value: function getView(segment) {
      return this.getQuartzCron().getView(segment);
    }
  }, {
    key: "setView",
    value: function setView(segment, view) {
      return this.getQuartzCron().setView(segment, view);
    }
  }, {
    key: "toggleSpecifics",
    value: function toggleSpecifics(value, mode, segment) {
      var view = this.getView(segment);
      var values = view.values[mode].values;

      if (!~values.indexOf(value)) {
        values.push(value);
      } else {
        var i = values.indexOf(value);
        values.splice(i, 1);
      }

      this.setView(segment, view);
      this.applyChanges();
    }
  }]);

  return TabBaseComponent;
}(CronBaseComponent);

var ReCronDay =
/*#__PURE__*/
function (_TabBaseComponent) {
  _inherits(ReCronDay, _TabBaseComponent);

  function ReCronDay(props) {
    var _this;

    _classCallCheck(this, ReCronDay);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ReCronDay).call(this, props, [Segment.dayOfMonth, Segment.dayOfWeek]));
    var coreService = new CoreService();
    var daysOfMonthEvery = coreService.getList(Segment.dayOfMonth, true);
    _this.state = {
      daysOfWeekEvery: coreService.getList(Segment.dayOfWeek, true),
      daysOfWeek: coreService.getList(Segment.dayOfWeek),
      daysOfWeekCodes: coreService.getDaysOfWeekCodes(),
      daysOfMonthEvery: daysOfMonthEvery,
      daysOfMonth: coreService.getList(Segment.dayOfMonth),
      limitedDaysOfMonth: daysOfMonthEvery.slice(0, 5),
      dayOfMonth: _this.getView(Segment.dayOfMonth),
      dayOfWeek: _this.getView(Segment.dayOfWeek)
    };
    return _this;
  }

  _createClass(ReCronDay, [{
    key: "render",
    value: function render() {
      return React.createElement("div", null, this.genEvery(), this.genDayOfWeekIncrement(), this.genDayOfMonthIncrement(), this.genDayOfWeekAnd(), this.genDayOfMonthAnd(), this.genDayOfMonthLastDay(), this.genDayOfMonthLastDayWeek(), this.genDayOfWeekLastNTHDayWeek(), this.genDayOfMonthDaysBeforeEndMonth(), this.genDayOfMonthNearestWeekDayOfMonth(), this.genDayOfWeekNTHWeekDayOfMonth());
    }
  }, {
    key: "genEvery",
    value: function genEvery() {
      var _this2 = this;

      return React.createElement("div", {
        className: this.genClassName(['form-group'], ['c-every-weekday'])
      }, React.createElement("div", {
        className: this.genClassName(['form-check'], ['c-every-weekday-check'])
      }, React.createElement("input", {
        className: this.genClassName(['form-check-input'], ['c-every-weekday-option']),
        type: "radio",
        id: this.genId(Mode.EVERY, Segment.dayOfWeek),
        value: Mode.EVERY,
        checked: this.state.dayOfWeek.selected === Mode.EVERY,
        disabled: this.isDisabled(),
        onChange: function onChange() {
          return _this2.setEvery();
        }
      }), React.createElement("label", {
        className: this.genClassName(['form-check-label'], ['c-every-weekday-option-label']),
        htmlFor: this.genId(Mode.EVERY, Segment.dayOfWeek)
      }, "Every day")));
    }
  }, {
    key: "genDayOfWeekIncrement",
    value: function genDayOfWeekIncrement() {
      var _this3 = this;

      return React.createElement("div", {
        className: this.genClassName(['form-group', 'form-inline'], ['c-increment-weekday'])
      }, React.createElement("div", {
        className: this.genClassName(['form-check'], ['c-increment-weekday-check'])
      }, React.createElement("input", {
        className: this.genClassName(['form-check-input'], ['c-increment-weekday-option']),
        type: "radio",
        id: this.genId(Mode.INCREMENT, Segment.dayOfWeek),
        value: Mode.INCREMENT,
        checked: this.state.dayOfWeek.selected === Mode.INCREMENT,
        disabled: this.isDisabled(),
        onChange: function onChange() {
          return _this3.setSelected(Mode.INCREMENT, Segment.dayOfWeek, Segment.dayOfMonth);
        }
      }), React.createElement("label", {
        className: this.genClassName(['form-check-label'], ['c-increment-weekday-option-label']),
        htmlFor: this.genId(Mode.INCREMENT, Segment.dayOfWeek)
      }, "Every")), React.createElement("select", {
        className: this.genClassName(['form-control', 'form-control-sm', 'mx-1'], ['c-increment-weekday-every']),
        disabled: this.isDisabled(Mode.INCREMENT, Segment.dayOfWeek),
        value: this.getValues(Mode.INCREMENT, Segment.dayOfWeek)[1],
        onChange: function onChange(e) {
          return _this3.setInValue(Mode.INCREMENT, 1, e.target.value, Segment.dayOfWeek);
        }
      }, this.state.daysOfWeekEvery.map(function (item) {
        return React.createElement("option", {
          value: item.value,
          key: item.value
        }, item.value);
      })), React.createElement("label", {
        className: "c-increment-weekday-option-label2",
        htmlFor: this.genId(Mode.INCREMENT, Segment.dayOfWeek)
      }, "day(s) starting on"), React.createElement("select", {
        className: this.genClassName(['form-control', 'form-control-sm', 'mx-1'], ['c-increment-weekday-from']),
        disabled: this.isDisabled(Mode.INCREMENT, Segment.dayOfWeek),
        value: this.getValues(Mode.INCREMENT, Segment.dayOfWeek)[0],
        onChange: function onChange(e) {
          return _this3.setInValue(Mode.INCREMENT, 0, e.target.value, Segment.dayOfWeek);
        }
      }, this.state.daysOfWeek.map(function (item) {
        return React.createElement("option", {
          key: item.value,
          value: item.value
        }, item.label);
      })));
    }
  }, {
    key: "genDayOfMonthIncrement",
    value: function genDayOfMonthIncrement() {
      var _this4 = this;

      return React.createElement("div", {
        className: this.genClassName(['form-group', 'form-inline'], ['c-increment-monthday'])
      }, React.createElement("div", {
        className: this.genClassName(['form-check'], ['c-increment-monthday-check'])
      }, React.createElement("input", {
        className: this.genClassName(['form-check-input'], ['c-increment-monthday-option']),
        type: "radio",
        id: this.genId(Mode.INCREMENT, Segment.dayOfMonth),
        value: Mode.INCREMENT,
        checked: this.state.dayOfMonth.selected === Mode.INCREMENT,
        disabled: this.isDisabled(),
        onChange: function onChange() {
          return _this4.setSelected(Mode.INCREMENT, Segment.dayOfMonth, Segment.dayOfWeek);
        }
      }), React.createElement("label", {
        className: this.genClassName(['form-check-label'], ['c-increment-monthday-option-label']),
        htmlFor: this.genId(Mode.INCREMENT, Segment.dayOfMonth)
      }, "Every")), React.createElement("select", {
        className: this.genClassName(['form-control', 'form-control-sm', 'mx-1'], ['c-increment-monthday-every']),
        disabled: this.isDisabled(Mode.INCREMENT, Segment.dayOfMonth),
        value: this.getValues(Mode.INCREMENT, Segment.dayOfMonth)[1],
        onChange: function onChange(e) {
          return _this4.setInValue(Mode.INCREMENT, 1, e.target.value, Segment.dayOfMonth);
        }
      }, this.state.daysOfMonth.map(function (item) {
        return React.createElement("option", {
          key: item.value,
          value: item.value
        }, item.value);
      })), React.createElement("label", {
        className: "c-increment-monthday-option-label2",
        htmlFor: this.genId(Mode.INCREMENT, Segment.dayOfMonth)
      }, "day(s) starting on the"), React.createElement("select", {
        className: this.genClassName(['form-control', 'form-control-sm', 'mx-1'], ['c-increment-monthday-from']),
        disabled: this.isDisabled(Mode.INCREMENT, Segment.dayOfMonth),
        value: this.getValues(Mode.INCREMENT, Segment.dayOfMonth)[0],
        onChange: function onChange(e) {
          return _this4.setInValue(Mode.INCREMENT, 0, e.target.value, Segment.dayOfMonth);
        }
      }, this.state.daysOfMonthEvery.map(function (item) {
        return React.createElement("option", {
          key: item.value,
          value: item.value
        }, item.label);
      })), React.createElement("label", {
        className: "c-increment-monthday-option-label3",
        htmlFor: this.genId(Mode.INCREMENT, Segment.dayOfMonth)
      }, "of the month"));
    }
  }, {
    key: "genDayOfWeekAnd",
    value: function genDayOfWeekAnd() {
      var _this5 = this;

      return React.createElement("div", {
        className: this.genClassName(['form-group'], ['c-and-weekday'])
      }, React.createElement("div", {
        className: this.genClassName(['form-check'], ['c-and-weekday-check'])
      }, React.createElement("input", {
        className: this.genClassName(['form-check-input'], ['c-and-weekday-option']),
        type: "radio",
        id: this.genId(Mode.AND, Segment.dayOfWeek),
        value: Mode.INCREMENT,
        checked: this.state.dayOfWeek.selected === Mode.AND,
        disabled: this.isDisabled(),
        onChange: function onChange() {
          return _this5.setSelected(Mode.AND, Segment.dayOfWeek, Segment.dayOfMonth);
        }
      }), React.createElement("label", {
        className: this.genClassName(['form-check-label'], ['c-and-weekday-option-label']),
        htmlFor: this.genId(Mode.AND, Segment.dayOfWeek)
      }, "Specific day of week (choose one or many)")), React.createElement("div", {
        className: this.genClassName(['row', 'pl-3', 'pt-1'], ['c-and-weekday-list'])
      }, this.state.daysOfWeekCodes.map(function (item) {
        return React.createElement("div", {
          className: _this5.genClassName(['col-2'], ['c-and-weekday-item']),
          "item-value": item.value,
          key: item.value
        }, React.createElement("div", {
          className: _this5.genClassName(['form-check'], ['c-and-weekday-item-check'])
        }, React.createElement("input", {
          className: _this5.genClassName(['form-check-input'], ['c-and-weekday-item-field']),
          type: "checkbox",
          id: _this5.genId(Mode.AND, Segment.dayOfWeek + item.value),
          value: item.value,
          disabled: _this5.isDisabled(Mode.AND, Segment.dayOfWeek),
          checked: _this5.inSpecificsList(item.value, Mode.AND, Segment.dayOfWeek),
          onChange: function onChange() {
            return _this5.toggleSpecifics(item.value, Mode.AND, Segment.dayOfWeek);
          }
        }), React.createElement("label", {
          className: _this5.genClassName(['form-check-label'], ['c-and-weekday-item-label']),
          htmlFor: _this5.genId(Mode.AND, Segment.dayOfWeek + item.value)
        }, item.label)));
      })));
    }
  }, {
    key: "genDayOfMonthAnd",
    value: function genDayOfMonthAnd() {
      var _this6 = this;

      return React.createElement("div", {
        className: this.genClassName(['form-group'], ['c-and-monthday'])
      }, React.createElement("div", {
        className: this.genClassName(['form-check'], ['c-and-monthday-check'])
      }, React.createElement("input", {
        className: this.genClassName(['form-check-input'], ['c-and-monthday-option']),
        type: "radio",
        id: this.genId(Mode.AND, Segment.dayOfMonth),
        value: Mode.INCREMENT,
        checked: this.state.dayOfMonth.selected === Mode.AND,
        disabled: this.isDisabled(),
        onChange: function onChange() {
          return _this6.setSelected(Mode.AND, Segment.dayOfMonth, Segment.dayOfWeek);
        }
      }), React.createElement("label", {
        className: this.genClassName(['form-check-label'], ['c-and-monthday-option-label']),
        htmlFor: this.genId(Mode.AND, Segment.dayOfMonth)
      }, "Specific day of month (choose one or many)")), React.createElement("div", {
        className: this.genClassName(['row', 'pl-3', 'pt-1'], ['c-and-monthday-list'])
      }, this.state.daysOfMonth.map(function (item) {
        return React.createElement("div", {
          className: _this6.genClassName(['col-1'], ['c-and-monthday-item']),
          "item-value": item.value,
          key: item.value
        }, React.createElement("div", {
          className: _this6.genClassName(['form-check'], ['c-and-monthday-item-check'])
        }, React.createElement("input", {
          className: _this6.genClassName(['form-check-input'], ['c-and-monthday-item-field']),
          type: "checkbox",
          id: _this6.genId(Mode.AND, Segment.dayOfMonth + item.value),
          value: item.value,
          disabled: _this6.isDisabled(Mode.AND, Segment.dayOfMonth),
          checked: _this6.inSpecificsList(item.value, Mode.AND, Segment.dayOfMonth),
          onChange: function onChange() {
            return _this6.toggleSpecifics(item.value, Mode.AND, Segment.dayOfMonth);
          }
        }), React.createElement("label", {
          className: _this6.genClassName(['form-check-label'], ['c-and-monthday-item-label']),
          htmlFor: _this6.genId(Mode.AND, Segment.dayOfMonth + item.value)
        }, item.label)));
      })));
    }
  }, {
    key: "genDayOfMonthLastDay",
    value: function genDayOfMonthLastDay() {
      var _this7 = this;

      return React.createElement("div", {
        className: this.genClassName(['form-group'], ['c-last-monthday'])
      }, React.createElement("div", {
        className: this.genClassName(['form-check'], ['c-last-monthday-check'])
      }, React.createElement("input", {
        className: this.genClassName(['form-check-input'], ['c-last-monthday-option']),
        type: "radio",
        id: this.genId(Mode.LAST_DAY, Segment.dayOfMonth),
        value: Mode.LAST_DAY,
        checked: this.state.dayOfMonth.selected === Mode.LAST_DAY,
        disabled: this.isDisabled(),
        onChange: function onChange() {
          return _this7.setSelected(Mode.LAST_DAY, Segment.dayOfMonth, Segment.dayOfWeek, 'L');
        }
      }), React.createElement("label", {
        className: this.genClassName(['form-check-label'], ['c-last-monthday-option-label']),
        htmlFor: this.genId(Mode.LAST_DAY, Segment.dayOfMonth)
      }, "On the last day of the month")));
    }
  }, {
    key: "genDayOfMonthLastDayWeek",
    value: function genDayOfMonthLastDayWeek() {
      var _this8 = this;

      return React.createElement("div", {
        className: this.genClassName(['form-group'], ['c-last-weekday'])
      }, React.createElement("div", {
        className: this.genClassName(['form-check'], ['c-last-weekday-check'])
      }, React.createElement("input", {
        className: this.genClassName(['form-check-input'], ['c-last-weekday-option']),
        type: "radio",
        id: this.genId(Mode.LAST_DAY_WEEK, Segment.dayOfMonth),
        value: Mode.LAST_DAY_WEEK,
        checked: this.state.dayOfMonth.selected === Mode.LAST_DAY_WEEK,
        disabled: this.isDisabled(),
        onChange: function onChange() {
          return _this8.setSelected(Mode.LAST_DAY_WEEK, Segment.dayOfMonth, Segment.dayOfWeek, 'LW');
        }
      }), React.createElement("label", {
        className: this.genClassName(['form-check-label'], ['c-last-weekday-option-label']),
        htmlFor: this.genId(Mode.LAST_DAY_WEEK, Segment.dayOfMonth)
      }, "On the last weekday of the month")));
    }
  }, {
    key: "genDayOfWeekLastNTHDayWeek",
    value: function genDayOfWeekLastNTHDayWeek() {
      var _this9 = this;

      return React.createElement("div", {
        className: this.genClassName(['form-group', 'form-inline'], ['c-last-nth'])
      }, React.createElement("div", {
        className: this.genClassName(['form-check'], ['c-last-nth-check'])
      }, React.createElement("input", {
        className: this.genClassName(['form-check-input'], ['c-last-nth-option']),
        type: "radio",
        id: this.genId(Mode.LAST_NTH_DAY_WEEK, Segment.dayOfWeek),
        value: Mode.LAST_NTH_DAY_WEEK,
        checked: this.state.dayOfWeek.selected === Mode.LAST_NTH_DAY_WEEK,
        disabled: this.isDisabled(),
        onChange: function onChange() {
          return _this9.setSelected(Mode.LAST_NTH_DAY_WEEK, Segment.dayOfWeek, Segment.dayOfMonth);
        }
      }), React.createElement("label", {
        className: this.genClassName(['form-check-label'], ['c-last-nth-option-label']),
        htmlFor: this.genId(Mode.LAST_NTH_DAY_WEEK, Segment.dayOfWeek)
      }, "On the last")), React.createElement("select", {
        className: this.genClassName(['form-control', 'form-control-sm', 'mx-1'], ['c-last-nth-weekday']),
        disabled: this.isDisabled(Mode.LAST_NTH_DAY_WEEK, Segment.dayOfWeek),
        value: this.getValues(Mode.LAST_NTH_DAY_WEEK, Segment.dayOfWeek)[0],
        onChange: function onChange(e) {
          return _this9.setInValue(Mode.LAST_NTH_DAY_WEEK, 0, e.target.value, Segment.dayOfWeek);
        }
      }, this.state.daysOfWeek.map(function (item) {
        return React.createElement("option", {
          value: item.value + 'L',
          key: item.value + 'L'
        }, item.label);
      })), React.createElement("label", {
        className: "c-last-nth-option-label2",
        htmlFor: this.genId(Mode.LAST_NTH_DAY_WEEK, Segment.dayOfWeek)
      }, "of the month"));
    }
  }, {
    key: "genDayOfMonthDaysBeforeEndMonth",
    value: function genDayOfMonthDaysBeforeEndMonth() {
      var _this10 = this;

      return React.createElement("div", {
        className: this.genClassName(['form-group', 'form-inline'], ['c-day-before-end'])
      }, React.createElement("div", {
        className: this.genClassName(['form-check'], ['c-day-before-end-check'])
      }, React.createElement("input", {
        className: this.genClassName(['form-check-input'], ['c-day-before-end-option']),
        type: "radio",
        id: this.genId(Mode.DAYS_BEFORE_END_MONTH, Segment.dayOfMonth),
        value: Mode.DAYS_BEFORE_END_MONTH,
        checked: this.state.dayOfMonth.selected === Mode.DAYS_BEFORE_END_MONTH,
        disabled: this.isDisabled(),
        onChange: function onChange() {
          return _this10.setSelected(Mode.DAYS_BEFORE_END_MONTH, Segment.dayOfMonth, Segment.dayOfWeek);
        }
      })), React.createElement("select", {
        className: this.genClassName(['form-control', 'form-control-sm', 'mx-1'], ['c-day-before-end-monthday']),
        disabled: this.isDisabled(Mode.DAYS_BEFORE_END_MONTH, Segment.dayOfMonth),
        value: this.getValues(Mode.DAYS_BEFORE_END_MONTH, Segment.dayOfMonth)[0],
        onChange: function onChange(e) {
          return _this10.setInValue(Mode.DAYS_BEFORE_END_MONTH, 0, e.target.value, Segment.dayOfMonth);
        }
      }, this.state.daysOfMonth.map(function (item) {
        return React.createElement("option", {
          value: 'L-' + item.value,
          key: 'L-' + item.value
        }, item.label);
      })), React.createElement("label", {
        className: "c-day-before-end-option-label",
        htmlFor: this.genId(Mode.DAYS_BEFORE_END_MONTH, Segment.dayOfMonth)
      }, "day(s) before the end of the month"));
    }
  }, {
    key: "genDayOfMonthNearestWeekDayOfMonth",
    value: function genDayOfMonthNearestWeekDayOfMonth() {
      var _this11 = this;

      return React.createElement("div", {
        className: this.genClassName(['form-group', 'form-inline'], ['c-nearest'])
      }, React.createElement("div", {
        className: this.genClassName(['form-check'], ['c-nearest-check'])
      }, React.createElement("input", {
        className: this.genClassName(['form-check-input'], ['c-nearest-option']),
        type: "radio",
        id: this.genId(Mode.NEAREST_WEEKDAY_OF_MONTH, Segment.dayOfMonth),
        value: Mode.NEAREST_WEEKDAY_OF_MONTH,
        checked: this.state.dayOfMonth.selected === Mode.NEAREST_WEEKDAY_OF_MONTH,
        disabled: this.isDisabled(),
        onChange: function onChange() {
          return _this11.setSelected(Mode.NEAREST_WEEKDAY_OF_MONTH, Segment.dayOfMonth, Segment.dayOfWeek);
        }
      }), React.createElement("label", {
        className: this.genClassName(['form-check-label'], ['c-nearest-option-label']),
        htmlFor: this.genId(Mode.NEAREST_WEEKDAY_OF_MONTH, Segment.dayOfMonth)
      }, "Nearest weekday (Monday to Friday) to the")), React.createElement("select", {
        className: this.genClassName(['form-control', 'form-control-sm', 'mx-1'], ['c-nearest-monthday']),
        disabled: this.isDisabled(Mode.NEAREST_WEEKDAY_OF_MONTH, Segment.dayOfMonth),
        value: this.getValues(Mode.NEAREST_WEEKDAY_OF_MONTH, Segment.dayOfMonth)[0],
        onChange: function onChange(e) {
          return _this11.setInValue(Mode.NEAREST_WEEKDAY_OF_MONTH, 0, e.target.value, Segment.dayOfMonth);
        }
      }, this.state.daysOfMonthEvery.map(function (item) {
        return React.createElement("option", {
          key: item.value + 'W',
          value: item.value + 'W'
        }, item.label);
      })), React.createElement("label", {
        className: "c-nearest-option-label2",
        htmlFor: this.genId(Mode.NEAREST_WEEKDAY_OF_MONTH, Segment.dayOfMonth)
      }, "of the month"));
    }
  }, {
    key: "genDayOfWeekNTHWeekDayOfMonth",
    value: function genDayOfWeekNTHWeekDayOfMonth() {
      var _this12 = this;

      return React.createElement("div", {
        className: this.genClassName(['form-group', 'form-inline'], ['c-nth'])
      }, React.createElement("div", {
        className: this.genClassName(['form-check'], ['c-nth-check'])
      }, React.createElement("input", {
        className: this.genClassName(['form-check-input'], ['c-nth-option']),
        type: "radio",
        id: this.genId(Mode.NTH_WEEKDAY_OF_MONTH, Segment.dayOfWeek),
        value: Mode.NTH_WEEKDAY_OF_MONTH,
        checked: this.state.dayOfWeek.selected === Mode.NTH_WEEKDAY_OF_MONTH,
        disabled: this.isDisabled(),
        onChange: function onChange() {
          return _this12.setSelected(Mode.NTH_WEEKDAY_OF_MONTH, Segment.dayOfWeek, Segment.dayOfMonth);
        }
      }), React.createElement("label", {
        className: this.genClassName(['form-check-label'], ['c-nth-option-label']),
        htmlFor: this.genId(Mode.NTH_WEEKDAY_OF_MONTH, Segment.dayOfWeek)
      }, "On the")), React.createElement("select", {
        className: this.genClassName(['form-control', 'form-control-sm', 'mx-1'], ['c-nth-every']),
        disabled: this.isDisabled(Mode.NTH_WEEKDAY_OF_MONTH, Segment.dayOfWeek),
        value: this.getValues(Mode.NTH_WEEKDAY_OF_MONTH, Segment.dayOfWeek)[1],
        onChange: function onChange(e) {
          return _this12.setInValue(Mode.NTH_WEEKDAY_OF_MONTH, 1, e.target.value, Segment.dayOfWeek);
        }
      }, this.state.limitedDaysOfMonth.map(function (item) {
        return React.createElement("option", {
          value: item.value,
          key: item.value
        }, item.label);
      })), React.createElement("select", {
        className: this.genClassName(['form-control', 'form-control-sm', 'mx-1'], ['c-nth-every-weekday']),
        disabled: this.isDisabled(Mode.NTH_WEEKDAY_OF_MONTH, Segment.dayOfWeek),
        value: this.getValues(Mode.NTH_WEEKDAY_OF_MONTH, Segment.dayOfWeek)[0],
        onChange: function onChange(e) {
          return _this12.setInValue(Mode.NTH_WEEKDAY_OF_MONTH, 0, e.target.value, Segment.dayOfWeek);
        }
      }, this.state.daysOfWeek.map(function (item) {
        return React.createElement("option", {
          key: item.value,
          value: item.value
        }, item.label);
      })), React.createElement("label", {
        className: "c-nth-option-label2",
        htmlFor: this.genId(Mode.NTH_WEEKDAY_OF_MONTH, Segment.dayOfWeek)
      }, "of the month"));
    }
  }, {
    key: "setEvery",
    value: function setEvery() {
      var dayOfMonth = this.getView(Segment.dayOfMonth);
      dayOfMonth.values.NONE.values = ['?'];
      dayOfMonth.selected = Mode.NONE;
      this.setView(Segment.dayOfMonth, dayOfMonth);
      var dayOfWeek = this.getView(Segment.dayOfWeek);
      dayOfWeek.values.EVERY.values = ['*'];
      dayOfWeek.selected = Mode.EVERY;
      this.setView(Segment.dayOfWeek, dayOfWeek);
      this.applyChanges();
    }
  }, {
    key: "setSelected",
    value: function setSelected(mode, segment, reset, value) {
      var view = this.getView(segment);
      view.selected = mode;
      this.setView(segment, view);

      if (reset === Segment.dayOfMonth) {
        this.resetsDaysOfMonth();
      }

      if (reset === Segment.dayOfWeek) {
        this.resetDaysOfWeek();
      }

      if (value) {
        this.setInValue(mode, 0, value, segment);
      }

      this.applyChanges();
    }
  }, {
    key: "resetsDaysOfMonth",
    value: function resetsDaysOfMonth() {
      var dayOfMonth = this.getView(Segment.dayOfMonth);
      dayOfMonth.selected = Mode.NONE;
      dayOfMonth.values.NONE.values = ['?'];
      this.setView(Segment.dayOfMonth, dayOfMonth);
    }
  }, {
    key: "resetDaysOfWeek",
    value: function resetDaysOfWeek() {
      var dayOfWeek = this.getView(Segment.dayOfWeek);
      dayOfWeek.selected = Mode.NONE;
      dayOfWeek.values.NONE.values = ['?'];
      this.setView(Segment.dayOfWeek, dayOfWeek);
    }
  }]);

  return ReCronDay;
}(TabBaseComponent);

var TabSingleSegmentComponent =
/*#__PURE__*/
function (_TabBaseComponent) {
  _inherits(TabSingleSegmentComponent, _TabBaseComponent);

  function TabSingleSegmentComponent(props, segment) {
    var _this;

    _classCallCheck(this, TabSingleSegmentComponent);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TabSingleSegmentComponent).call(this, props, [segment]));
    _this.segment = segment;
    return _this;
  }

  _createClass(TabSingleSegmentComponent, [{
    key: "render",
    value: function render() {
      return React.createElement("div", null, this.genEvery(), this.genIncrement(), this.genAnd(), this.genRange());
    }
  }, {
    key: "setEvery",
    value: function setEvery() {
      var view = this.getView(this.segment);
      view.values.EVERY.values = ['*'];
      this.setView(this.segment, view);
      this.setSelected(Mode.EVERY);
    }
  }, {
    key: "setSelected",
    value: function setSelected(mode) {
      var view = this.getView(this.segment);
      view.selected = mode;
      this.setView(this.segment, view);
      this.applyChanges();
    }
  }, {
    key: "setInValue",
    value: function setInValue(mode, index, value) {
      _get(_getPrototypeOf(TabSingleSegmentComponent.prototype), "setInValue", this).call(this, mode, index, value, this.segment);
    }
  }, {
    key: "inSpecificsList",
    value: function inSpecificsList(value, mode) {
      return _get(_getPrototypeOf(TabSingleSegmentComponent.prototype), "inSpecificsList", this).call(this, value, mode, this.segment);
    }
  }, {
    key: "getValues",
    value: function getValues(mode) {
      return _get(_getPrototypeOf(TabSingleSegmentComponent.prototype), "getValues", this).call(this, mode, this.segment);
    }
  }, {
    key: "toggleSpecifics",
    value: function toggleSpecifics(value, mode) {
      _get(_getPrototypeOf(TabSingleSegmentComponent.prototype), "toggleSpecifics", this).call(this, value, mode, this.segment);
    }
  }, {
    key: "isDisabled",
    value: function isDisabled(mode) {
      return _get(_getPrototypeOf(TabSingleSegmentComponent.prototype), "isDisabled", this).call(this, mode, this.segment);
    }
  }]);

  return TabSingleSegmentComponent;
}(TabBaseComponent);

var ReCronHour =
/*#__PURE__*/
function (_TabSingleSegmentComp) {
  _inherits(ReCronHour, _TabSingleSegmentComp);

  function ReCronHour(props) {
    var _this;

    _classCallCheck(this, ReCronHour);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ReCronHour).call(this, props, Segment.hours));
    var coreService = new CoreService();
    _this.state = {
      hourCodes: coreService.getList(Segment.hours, true),
      hoursList: coreService.getList(Segment.hours),
      hours: _this.getView(Segment.hours)
    };
    return _this;
  }

  _createClass(ReCronHour, [{
    key: "genEvery",
    value: function genEvery() {
      var _this2 = this;

      return React.createElement("div", {
        className: this.genClassName(['form-group'], ['c-every'])
      }, React.createElement("div", {
        className: this.genClassName(['form-check'], ['c-every-check'])
      }, React.createElement("input", {
        className: this.genClassName(['form-check-input'], ['c-every-option']),
        type: "radio",
        id: this.genId(Mode.EVERY),
        value: Mode.EVERY,
        checked: this.state.hours.selected === Mode.EVERY,
        disabled: this.isDisabled(),
        onChange: function onChange() {
          _this2.setEvery();
        }
      }), React.createElement("label", {
        className: this.genClassName(['form-check-label'], ['c-every-option-label']),
        htmlFor: this.genId(Mode.EVERY)
      }, "Every hour")));
    }
  }, {
    key: "genIncrement",
    value: function genIncrement() {
      var _this3 = this;

      return React.createElement("div", {
        className: this.genClassName(['form-group', 'form-inline'], ['c-increment'])
      }, React.createElement("div", {
        className: this.genClassName(['form-check'], ['c-increment-check'])
      }, React.createElement("input", {
        className: this.genClassName(['form-check-input'], ['c-increment-option']),
        type: "radio",
        id: this.genId(Mode.INCREMENT),
        value: Mode.INCREMENT,
        checked: this.state.hours.selected === Mode.INCREMENT,
        disabled: this.isDisabled(),
        onChange: function onChange() {
          return _this3.setSelected(Mode.INCREMENT);
        }
      }), React.createElement("label", {
        className: this.genClassName(['form-check-label'], ['c-increment-option-label']),
        htmlFor: this.genId(Mode.INCREMENT)
      }, "Every")), React.createElement("select", {
        className: this.genClassName(['form-control', 'form-control-sm', 'mx-1'], ['c-increment-every']),
        disabled: this.isDisabled(Mode.INCREMENT),
        value: this.getValues(Mode.INCREMENT)[1],
        onChange: function onChange(e) {
          return _this3.setInValue(Mode.INCREMENT, 1, e.target.value);
        }
      }, this.state.hourCodes.map(function (item) {
        return React.createElement("option", {
          key: item.value,
          value: item.value
        }, item.value);
      })), React.createElement("label", {
        className: "c-increment-option-label2",
        htmlFor: this.genId(Mode.INCREMENT)
      }, "hour(s) starting at hour"), React.createElement("select", {
        className: this.genClassName(['form-control', 'form-control-sm', 'ml-1'], ['c-increment-from']),
        disabled: this.isDisabled(Mode.INCREMENT),
        value: this.getValues(Mode.INCREMENT)[0],
        onChange: function onChange(e) {
          return _this3.setInValue(Mode.INCREMENT, 0, e.target.value);
        }
      }, this.state.hoursList.map(function (item) {
        return React.createElement("option", {
          key: item.value,
          value: item.value
        }, item.label);
      })));
    }
  }, {
    key: "genAnd",
    value: function genAnd() {
      var _this4 = this;

      return React.createElement("div", {
        className: this.genClassName(['form-group'], ['c-and'])
      }, React.createElement("div", {
        className: this.genClassName(['form-check'], ['c-and-check'])
      }, React.createElement("input", {
        className: this.genClassName(['form-check-input'], ['c-and-option']),
        type: "radio",
        id: this.genId(Mode.AND),
        value: Mode.AND,
        checked: this.state.hours.selected === Mode.AND,
        disabled: this.isDisabled(),
        onChange: function onChange() {
          return _this4.setSelected(Mode.AND);
        }
      }), React.createElement("label", {
        className: this.genClassName(['form-check-label'], ['c-and-option-label']),
        htmlFor: this.genId(Mode.AND)
      }, "Specific hour (choose one or many)")), React.createElement("div", {
        className: this.genClassName(['row', 'pl-3', 'pt-1'], ['c-and-list'])
      }, this.state.hoursList.map(function (item) {
        return React.createElement("div", {
          className: _this4.genClassName(['col-1'], ['c-and-item']),
          "item-value": item.value,
          key: _this4.genId(Mode.AND, item.value)
        }, React.createElement("div", {
          className: _this4.genClassName(['form-check'], ['c-and-item-check'])
        }, React.createElement("input", {
          className: _this4.genClassName(['form-check-input'], ['c-and-item-field']),
          type: "checkbox",
          id: _this4.genId(Mode.AND, item.value),
          value: item.value,
          disabled: _this4.isDisabled(Mode.AND),
          checked: _this4.inSpecificsList(item.value, Mode.AND),
          onChange: function onChange() {
            return _this4.toggleSpecifics(item.value, Mode.AND);
          }
        }), React.createElement("label", {
          className: _this4.genClassName(['form-check-label'], ['c-and-item-label']),
          htmlFor: _this4.genId(Mode.AND, item.value)
        }, item.label)));
      })));
    }
  }, {
    key: "genRange",
    value: function genRange() {
      var _this5 = this;

      return React.createElement("div", {
        className: this.genClassName(['form-group', 'form-inline'], ['c-range'])
      }, React.createElement("div", {
        className: this.genClassName(['form-check'], ['c-range-check'])
      }, React.createElement("input", {
        className: this.genClassName(['form-check-input'], ['c-range-option']),
        type: "radio",
        id: this.genId(Mode.RANGE),
        value: Mode.RANGE,
        checked: this.state.hours.selected === Mode.RANGE,
        disabled: this.isDisabled(),
        onChange: function onChange() {
          return _this5.setSelected(Mode.RANGE);
        }
      }), React.createElement("label", {
        className: this.genClassName(['form-check-label'], ['c-range-option-label']),
        htmlFor: this.genId(Mode.RANGE)
      }, "Every hour between hour")), React.createElement("select", {
        className: this.genClassName(['form-control', 'form-control-sm', 'mx-1'], ['c-range-from']),
        disabled: this.isDisabled(Mode.RANGE),
        value: this.getValues(Mode.RANGE)[0],
        onChange: function onChange(e) {
          return _this5.setInValue(Mode.RANGE, 0, e.target.value);
        }
      }, this.state.hoursList.map(function (item) {
        return React.createElement("option", {
          key: item.value,
          value: item.value
        }, item.label);
      })), React.createElement("label", {
        className: "c-range-option-label2",
        htmlFor: this.genId(Mode.RANGE)
      }, "and hour"), React.createElement("select", {
        className: this.genClassName(['form-control', 'form-control-sm', 'ml-1'], ['c-range-to']),
        disabled: this.isDisabled(Mode.RANGE),
        value: this.getValues(Mode.RANGE)[1],
        onChange: function onChange(e) {
          return _this5.setInValue(Mode.RANGE, 1, e.target.value);
        }
      }, this.state.hoursList.map(function (item) {
        return React.createElement("option", {
          key: item.value,
          value: item.value
        }, item.label);
      })));
    }
  }]);

  return ReCronHour;
}(TabSingleSegmentComponent);

var ReCronMinute =
/*#__PURE__*/
function (_TabSingleSegmentComp) {
  _inherits(ReCronMinute, _TabSingleSegmentComp);

  function ReCronMinute(props) {
    var _this;

    _classCallCheck(this, ReCronMinute);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ReCronMinute).call(this, props, Segment.minutes));
    var coreService = new CoreService();
    _this.state = {
      minuteCodes: coreService.getList(Segment.minutes, true),
      minutesList: coreService.getList(Segment.minutes),
      minutes: _this.getView(Segment.minutes)
    };
    return _this;
  }

  _createClass(ReCronMinute, [{
    key: "genEvery",
    value: function genEvery() {
      var _this2 = this;

      return React.createElement("div", {
        className: this.genClassName(['form-group'], ['c-every'])
      }, React.createElement("div", {
        className: this.genClassName(['form-check'], ['c-every-check'])
      }, React.createElement("input", {
        className: this.genClassName(['form-check-input'], ['c-every-option']),
        type: "radio",
        id: this.genId(Mode.EVERY),
        value: Mode.EVERY,
        checked: this.state.minutes.selected === Mode.EVERY,
        disabled: this.isDisabled(),
        onChange: function onChange() {
          _this2.setEvery();
        }
      }), React.createElement("label", {
        className: this.genClassName(['form-check-label'], ['c-every-option-label']),
        htmlFor: this.genId(Mode.EVERY)
      }, "Every minute")));
    }
  }, {
    key: "genIncrement",
    value: function genIncrement() {
      var _this3 = this;

      return React.createElement("div", {
        className: this.genClassName(['form-group', 'form-inline'], ['c-increment'])
      }, React.createElement("div", {
        className: this.genClassName(['form-check'], ['c-increment-check'])
      }, React.createElement("input", {
        className: this.genClassName(['form-check-input'], ['c-increment-option']),
        type: "radio",
        id: this.genId(Mode.INCREMENT),
        value: Mode.INCREMENT,
        checked: this.state.minutes.selected === Mode.INCREMENT,
        disabled: this.isDisabled(),
        onChange: function onChange() {
          return _this3.setSelected(Mode.INCREMENT);
        }
      }), React.createElement("label", {
        className: this.genClassName(['form-check-label'], ['c-increment-option-label']),
        htmlFor: this.genId(Mode.INCREMENT)
      }, "Every")), React.createElement("select", {
        className: this.genClassName(['form-control', 'form-control-sm', 'mx-1'], ['c-increment-every']),
        disabled: this.isDisabled(Mode.INCREMENT),
        value: this.getValues(Mode.INCREMENT)[1],
        onChange: function onChange(e) {
          return _this3.setInValue(Mode.INCREMENT, 1, e.target.value);
        }
      }, this.state.minuteCodes.map(function (item) {
        return React.createElement("option", {
          key: item.value,
          value: item.value
        }, item.value);
      })), React.createElement("label", {
        className: "c-increment-option-label2",
        htmlFor: this.genId(Mode.INCREMENT)
      }, "minute(s) starting at minute"), React.createElement("select", {
        className: this.genClassName(['form-control', 'form-control-sm', 'ml-1'], ['c-increment-from']),
        disabled: this.isDisabled(Mode.INCREMENT),
        value: this.getValues(Mode.INCREMENT)[0],
        onChange: function onChange(e) {
          return _this3.setInValue(Mode.INCREMENT, 0, e.target.value);
        }
      }, this.state.minutesList.map(function (item) {
        return React.createElement("option", {
          key: item.value,
          value: item.value
        }, item.label);
      })));
    }
  }, {
    key: "genAnd",
    value: function genAnd() {
      var _this4 = this;

      return React.createElement("div", {
        className: this.genClassName(['form-group'], ['c-and'])
      }, React.createElement("div", {
        className: this.genClassName(['form-check'], ['c-and-check'])
      }, React.createElement("input", {
        className: this.genClassName(['form-check-input'], ['c-and-option']),
        type: "radio",
        id: this.genId(Mode.AND),
        value: Mode.AND,
        checked: this.state.minutes.selected === Mode.AND,
        disabled: this.isDisabled(),
        onChange: function onChange() {
          return _this4.setSelected(Mode.AND);
        }
      }), React.createElement("label", {
        className: this.genClassName(['form-check-label'], ['c-and-option-label']),
        htmlFor: this.genId(Mode.AND)
      }, "Specific minute (choose one or many)")), React.createElement("div", {
        className: this.genClassName(['row', 'pl-3', 'pt-1'], ['c-and-list'])
      }, this.state.minutesList.map(function (item) {
        return React.createElement("div", {
          className: _this4.genClassName(['col-1'], ['c-and-item']),
          "item-value": item.value,
          key: _this4.genId(Mode.AND, item.value)
        }, React.createElement("div", {
          className: _this4.genClassName(['form-check'], ['c-and-item-check'])
        }, React.createElement("input", {
          className: _this4.genClassName(['form-check-input'], ['c-and-item-field']),
          type: "checkbox",
          id: _this4.genId(Mode.AND, item.value),
          value: item.value,
          disabled: _this4.isDisabled(Mode.AND),
          checked: _this4.inSpecificsList(item.value, Mode.AND),
          onChange: function onChange() {
            return _this4.toggleSpecifics(item.value, Mode.AND);
          }
        }), React.createElement("label", {
          className: _this4.genClassName(['form-check-label'], ['c-and-item-label']),
          htmlFor: _this4.genId(Mode.AND, item.value)
        }, item.label)));
      })));
    }
  }, {
    key: "genRange",
    value: function genRange() {
      var _this5 = this;

      return React.createElement("div", {
        className: this.genClassName(['form-group', 'form-inline'], ['c-range'])
      }, React.createElement("div", {
        className: this.genClassName(['form-check'], ['c-range-check'])
      }, React.createElement("input", {
        className: this.genClassName(['form-check-input'], ['c-range-option']),
        type: "radio",
        id: this.genId(Mode.RANGE),
        value: Mode.RANGE,
        checked: this.state.minutes.selected === Mode.RANGE,
        disabled: this.isDisabled(),
        onChange: function onChange() {
          return _this5.setSelected(Mode.RANGE);
        }
      }), React.createElement("label", {
        className: this.genClassName(['form-check-label'], ['c-range-option-label']),
        htmlFor: this.genId(Mode.RANGE)
      }, "Every minute between minute")), React.createElement("select", {
        className: this.genClassName(['form-control', 'form-control-sm', 'mx-1'], ['c-range-from']),
        disabled: this.isDisabled(Mode.RANGE),
        value: this.getValues(Mode.RANGE)[0],
        onChange: function onChange(e) {
          return _this5.setInValue(Mode.RANGE, 0, e.target.value);
        }
      }, this.state.minutesList.map(function (item) {
        return React.createElement("option", {
          key: item.value,
          value: item.value
        }, item.label);
      })), React.createElement("label", {
        className: "c-range-option-label2",
        htmlFor: this.genId(Mode.RANGE)
      }, "and minute"), React.createElement("select", {
        className: this.genClassName(['form-control', 'form-control-sm', 'ml-1'], ['c-range-to']),
        disabled: this.isDisabled(Mode.RANGE),
        value: this.getValues(Mode.RANGE)[1],
        onChange: function onChange(e) {
          return _this5.setInValue(Mode.RANGE, 1, e.target.value);
        }
      }, this.state.minutesList.map(function (item) {
        return React.createElement("option", {
          key: item.value,
          value: item.value
        }, item.label);
      })));
    }
  }]);

  return ReCronMinute;
}(TabSingleSegmentComponent);

var ReCronMonth =
/*#__PURE__*/
function (_TabSingleSegmentComp) {
  _inherits(ReCronMonth, _TabSingleSegmentComp);

  function ReCronMonth(props) {
    var _this;

    _classCallCheck(this, ReCronMonth);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ReCronMonth).call(this, props, Segment.month));
    var coreService = new CoreService();
    _this.state = {
      monthCodes: coreService.getMonthCodes(),
      monthes: coreService.getList(Segment.month),
      month: _this.getView(Segment.month)
    };
    return _this;
  }

  _createClass(ReCronMonth, [{
    key: "genEvery",
    value: function genEvery() {
      var _this2 = this;

      return React.createElement("div", {
        className: this.genClassName(['form-group'], ['c-every'])
      }, React.createElement("div", {
        className: this.genClassName(['form-check'], ['c-every-check'])
      }, React.createElement("input", {
        className: this.genClassName(['form-check-input'], ['c-every-option']),
        type: "radio",
        id: this.genId(Mode.EVERY),
        value: Mode.EVERY,
        checked: this.state.month.selected === Mode.EVERY,
        disabled: this.isDisabled(),
        onChange: function onChange() {
          _this2.setEvery();
        }
      }), React.createElement("label", {
        className: this.genClassName(['form-check-label'], ['c-every-option-label']),
        htmlFor: this.genId(Mode.EVERY)
      }, "Every month")));
    }
  }, {
    key: "genIncrement",
    value: function genIncrement() {
      var _this3 = this;

      return React.createElement("div", {
        className: this.genClassName(['form-group', 'form-inline'], ['c-increment'])
      }, React.createElement("div", {
        className: this.genClassName(['form-check'], ['c-increment-check'])
      }, React.createElement("input", {
        className: this.genClassName(['form-check-input'], ['c-increment-option']),
        type: "radio",
        id: this.genId(Mode.INCREMENT),
        value: Mode.INCREMENT,
        checked: this.state.month.selected === Mode.INCREMENT,
        disabled: this.isDisabled(),
        onChange: function onChange() {
          return _this3.setSelected(Mode.INCREMENT);
        }
      }), React.createElement("label", {
        className: this.genClassName(['form-check-label'], ['c-increment-option-label']),
        htmlFor: this.genId(Mode.INCREMENT)
      }, "Every")), React.createElement("select", {
        className: this.genClassName(['form-control', 'form-control-sm', 'mx-1'], ['c-increment-every']),
        disabled: this.isDisabled(Mode.INCREMENT),
        value: this.getValues(Mode.INCREMENT)[1],
        onChange: function onChange(e) {
          return _this3.setInValue(Mode.INCREMENT, 1, e.target.value);
        }
      }, this.state.monthes.map(function (item, i) {
        return React.createElement("option", {
          key: item.value,
          value: item.value
        }, i + 1);
      })), React.createElement("label", {
        className: "c-increment-option-label2",
        htmlFor: this.genId(Mode.INCREMENT)
      }, "month(s) starting at month"), React.createElement("select", {
        className: this.genClassName(['form-control', 'form-control-sm', 'ml-1'], ['c-increment-from']),
        disabled: this.isDisabled(Mode.INCREMENT),
        value: this.getValues(Mode.INCREMENT)[0],
        onChange: function onChange(e) {
          return _this3.setInValue(Mode.INCREMENT, 0, e.target.value);
        }
      }, this.state.monthes.map(function (item) {
        return React.createElement("option", {
          key: item.value,
          value: item.value
        }, item.label);
      })));
    }
  }, {
    key: "genAnd",
    value: function genAnd() {
      var _this4 = this;

      return React.createElement("div", {
        className: this.genClassName(['form-group'], ['c-and'])
      }, React.createElement("div", {
        className: this.genClassName(['form-check'], ['c-and-check'])
      }, React.createElement("input", {
        className: this.genClassName(['form-check-input'], ['c-and-option']),
        type: "radio",
        id: this.genId(Mode.AND),
        value: Mode.AND,
        checked: this.state.month.selected === Mode.AND,
        disabled: this.isDisabled(),
        onChange: function onChange() {
          return _this4.setSelected(Mode.AND);
        }
      }), React.createElement("label", {
        className: this.genClassName(['form-check-label'], ['c-and-option-label']),
        htmlFor: this.genId(Mode.AND)
      }, "Specific month (choose one or many)")), React.createElement("div", {
        className: this.genClassName(['row', 'pl-3', 'pt-1'], ['c-and-list'])
      }, this.state.monthCodes.map(function (item) {
        return React.createElement("div", {
          className: _this4.genClassName(['col-2'], ['c-and-item']),
          "item-value": item.value,
          key: _this4.genId(Mode.AND, item.value)
        }, React.createElement("div", {
          className: _this4.genClassName(['form-check'], ['c-and-item-check'])
        }, React.createElement("input", {
          className: _this4.genClassName(['form-check-input'], ['c-and-item-field']),
          type: "checkbox",
          id: _this4.genId(Mode.AND, item.value),
          value: item.value,
          disabled: _this4.isDisabled(Mode.AND),
          checked: _this4.inSpecificsList(item.value, Mode.AND),
          onChange: function onChange() {
            return _this4.toggleSpecifics(item.value, Mode.AND);
          }
        }), React.createElement("label", {
          className: _this4.genClassName(['form-check-label'], ['c-and-item-label']),
          htmlFor: _this4.genId(Mode.AND, item.value)
        }, item.label)));
      })));
    }
  }, {
    key: "genRange",
    value: function genRange() {
      var _this5 = this;

      return React.createElement("div", {
        className: this.genClassName(['form-group', 'form-inline'], ['c-range'])
      }, React.createElement("div", {
        className: this.genClassName(['form-check'], ['c-range-check'])
      }, React.createElement("input", {
        className: this.genClassName(['form-check-input'], ['c-range-option']),
        type: "radio",
        id: this.genId(Mode.RANGE),
        value: Mode.RANGE,
        checked: this.state.month.selected === Mode.RANGE,
        disabled: this.isDisabled(),
        onChange: function onChange() {
          return _this5.setSelected(Mode.RANGE);
        }
      }), React.createElement("label", {
        className: this.genClassName(['form-check-label'], ['c-range-option-label']),
        htmlFor: this.genId(Mode.RANGE)
      }, "Every month between month")), React.createElement("select", {
        className: this.genClassName(['form-control', 'form-control-sm', 'mx-1'], ['c-range-from']),
        disabled: this.isDisabled(Mode.RANGE),
        value: this.getValues(Mode.RANGE)[0],
        onChange: function onChange(e) {
          return _this5.setInValue(Mode.RANGE, 0, e.target.value);
        }
      }, this.state.monthes.map(function (item) {
        return React.createElement("option", {
          key: item.value,
          value: item.value
        }, item.label);
      })), React.createElement("label", {
        className: "c-range-option-label2",
        htmlFor: this.genId(Mode.RANGE)
      }, "and month"), React.createElement("select", {
        className: this.genClassName(['form-control', 'form-control-sm', 'ml-1'], ['c-range-to']),
        disabled: this.isDisabled(Mode.RANGE),
        value: this.getValues(Mode.RANGE)[1],
        onChange: function onChange(e) {
          return _this5.setInValue(Mode.RANGE, 1, e.target.value);
        }
      }, this.state.monthes.map(function (item) {
        return React.createElement("option", {
          key: item.value,
          value: item.value
        }, item.label);
      })));
    }
  }]);

  return ReCronMonth;
}(TabSingleSegmentComponent);

var ReCronSecond =
/*#__PURE__*/
function (_TabSingleSegmentComp) {
  _inherits(ReCronSecond, _TabSingleSegmentComp);

  function ReCronSecond(props) {
    var _this;

    _classCallCheck(this, ReCronSecond);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ReCronSecond).call(this, props, Segment.seconds));
    var coreService = new CoreService();
    _this.state = {
      secondCodes: coreService.getList(Segment.seconds, true),
      secondsList: coreService.getList(Segment.seconds),
      seconds: _this.getView(Segment.seconds)
    };
    return _this;
  }

  _createClass(ReCronSecond, [{
    key: "genEvery",
    value: function genEvery() {
      var _this2 = this;

      return React.createElement("div", {
        className: this.genClassName(['form-group'], ['c-every'])
      }, React.createElement("div", {
        className: this.genClassName(['form-check'], ['c-every-check'])
      }, React.createElement("input", {
        className: this.genClassName(['form-check-input'], ['c-every-option']),
        type: "radio",
        id: this.genId(Mode.EVERY),
        value: Mode.EVERY,
        checked: this.state.seconds.selected === Mode.EVERY,
        disabled: this.isDisabled(),
        onChange: function onChange() {
          _this2.setEvery();
        }
      }), React.createElement("label", {
        className: this.genClassName(['form-check-label'], ['c-every-option-label']),
        htmlFor: this.genId(Mode.EVERY)
      }, "Every second")));
    }
  }, {
    key: "genIncrement",
    value: function genIncrement() {
      var _this3 = this;

      return React.createElement("div", {
        className: this.genClassName(['form-group', 'form-inline'], ['c-increment'])
      }, React.createElement("div", {
        className: this.genClassName(['form-check'], ['c-increment-check'])
      }, React.createElement("input", {
        className: this.genClassName(['form-check-input'], ['c-increment-option']),
        type: "radio",
        id: this.genId(Mode.INCREMENT),
        value: Mode.INCREMENT,
        checked: this.state.seconds.selected === Mode.INCREMENT,
        disabled: this.isDisabled(),
        onChange: function onChange() {
          return _this3.setSelected(Mode.INCREMENT);
        }
      }), React.createElement("label", {
        className: this.genClassName(['form-check-label'], ['c-increment-option-label']),
        htmlFor: this.genId(Mode.INCREMENT)
      }, "Every")), React.createElement("select", {
        className: this.genClassName(['form-control', 'form-control-sm', 'mx-1'], ['c-increment-every']),
        disabled: this.isDisabled(Mode.INCREMENT),
        value: this.getValues(Mode.INCREMENT)[1],
        onChange: function onChange(e) {
          return _this3.setInValue(Mode.INCREMENT, 1, e.target.value);
        }
      }, this.state.secondCodes.map(function (item) {
        return React.createElement("option", {
          key: item.value,
          value: item.value
        }, item.value);
      })), React.createElement("label", {
        className: "c-increment-option-label2",
        htmlFor: this.genId(Mode.INCREMENT)
      }, "second(s) starting at second"), React.createElement("select", {
        className: this.genClassName(['form-control', 'form-control-sm', 'ml-1'], ['c-increment-from']),
        disabled: this.isDisabled(Mode.INCREMENT),
        value: this.getValues(Mode.INCREMENT)[0],
        onChange: function onChange(e) {
          return _this3.setInValue(Mode.INCREMENT, 0, e.target.value);
        }
      }, this.state.secondsList.map(function (item) {
        return React.createElement("option", {
          key: item.value,
          value: item.value
        }, item.label);
      })));
    }
  }, {
    key: "genAnd",
    value: function genAnd() {
      var _this4 = this;

      return React.createElement("div", {
        className: this.genClassName(['form-group'], ['c-and'])
      }, React.createElement("div", {
        className: this.genClassName(['form-check'], ['c-and-check'])
      }, React.createElement("input", {
        className: this.genClassName(['form-check-input'], ['c-and-option']),
        type: "radio",
        id: this.genId(Mode.AND),
        value: Mode.AND,
        checked: this.state.seconds.selected === Mode.AND,
        disabled: this.isDisabled(),
        onChange: function onChange() {
          return _this4.setSelected(Mode.AND);
        }
      }), React.createElement("label", {
        className: this.genClassName(['form-check-label'], ['c-and-option-label']),
        htmlFor: this.genId(Mode.AND)
      }, "Specific second (choose one or many)")), React.createElement("div", {
        className: this.genClassName(['row', 'pl-3', 'pt-1'], ['c-and-list'])
      }, this.state.secondsList.map(function (item) {
        return React.createElement("div", {
          className: _this4.genClassName(['col-1'], ['c-and-item']),
          "item-value": item.value,
          key: _this4.genId(Mode.AND, item.value)
        }, React.createElement("div", {
          className: _this4.genClassName(['form-check'], ['c-and-item-check'])
        }, React.createElement("input", {
          className: _this4.genClassName(['form-check-input'], ['c-and-item-field']),
          type: "checkbox",
          id: _this4.genId(Mode.AND, item.value),
          value: item.value,
          disabled: _this4.isDisabled(Mode.AND),
          checked: _this4.inSpecificsList(item.value, Mode.AND),
          onChange: function onChange() {
            return _this4.toggleSpecifics(item.value, Mode.AND);
          }
        }), React.createElement("label", {
          className: _this4.genClassName(['form-check-label'], ['c-and-item-label']),
          htmlFor: _this4.genId(Mode.AND, item.value)
        }, item.label)));
      })));
    }
  }, {
    key: "genRange",
    value: function genRange() {
      var _this5 = this;

      return React.createElement("div", {
        className: this.genClassName(['form-group', 'form-inline'], ['c-range'])
      }, React.createElement("div", {
        className: this.genClassName(['form-check'], ['c-range-check'])
      }, React.createElement("input", {
        className: this.genClassName(['form-check-input'], ['c-range-option']),
        type: "radio",
        id: this.genId(Mode.RANGE),
        value: Mode.RANGE,
        checked: this.state.seconds.selected === Mode.RANGE,
        disabled: this.isDisabled(),
        onChange: function onChange() {
          return _this5.setSelected(Mode.RANGE);
        }
      }), React.createElement("label", {
        className: this.genClassName(['form-check-label'], ['c-range-option-label']),
        htmlFor: this.genId(Mode.RANGE)
      }, "Every second between second")), React.createElement("select", {
        className: this.genClassName(['form-control', 'form-control-sm', 'mx-1'], ['c-range-from']),
        disabled: this.isDisabled(Mode.RANGE),
        value: this.getValues(Mode.RANGE)[0],
        onChange: function onChange(e) {
          return _this5.setInValue(Mode.RANGE, 0, e.target.value);
        }
      }, this.state.secondsList.map(function (item) {
        return React.createElement("option", {
          key: item.value,
          value: item.value
        }, item.label);
      })), React.createElement("label", {
        className: "c-range-option-label2",
        htmlFor: this.genId(Mode.RANGE)
      }, "and second"), React.createElement("select", {
        className: this.genClassName(['form-control', 'form-control-sm', 'ml-1'], ['c-range-to']),
        disabled: this.isDisabled(Mode.RANGE),
        value: this.getValues(Mode.RANGE)[1],
        onChange: function onChange(e) {
          return _this5.setInValue(Mode.RANGE, 1, e.target.value);
        }
      }, this.state.secondsList.map(function (item) {
        return React.createElement("option", {
          key: item.value,
          value: item.value
        }, item.label);
      })));
    }
  }]);

  return ReCronSecond;
}(TabSingleSegmentComponent);

var ReCronYear =
/*#__PURE__*/
function (_TabSingleSegmentComp) {
  _inherits(ReCronYear, _TabSingleSegmentComp);

  function ReCronYear(props) {
    var _this;

    _classCallCheck(this, ReCronYear);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ReCronYear).call(this, props, Segment.year));
    var coreService = new CoreService();
    _this.state = {
      yearCodes: coreService.getList(Segment.year, true),
      years: coreService.getList(Segment.year),
      year: _this.getView(Segment.year)
    };
    return _this;
  }

  _createClass(ReCronYear, [{
    key: "genEvery",
    value: function genEvery() {
      var _this2 = this;

      return React.createElement("div", {
        className: this.genClassName(['form-group'], ['c-every'])
      }, React.createElement("div", {
        className: this.genClassName(['form-check'], ['c-every-check'])
      }, React.createElement("input", {
        className: this.genClassName(['form-check-input'], ['c-every-option']),
        type: "radio",
        id: this.genId(Mode.EVERY),
        value: Mode.EVERY,
        checked: this.state.year.selected === Mode.EVERY,
        disabled: this.isDisabled(),
        onChange: function onChange() {
          _this2.setEvery();
        }
      }), React.createElement("label", {
        className: this.genClassName(['form-check-label'], ['c-every-option-label']),
        htmlFor: this.genId(Mode.EVERY)
      }, "Any year")));
    }
  }, {
    key: "genIncrement",
    value: function genIncrement() {
      var _this3 = this;

      return React.createElement("div", {
        className: this.genClassName(['form-group', 'form-inline'], ['c-increment'])
      }, React.createElement("div", {
        className: this.genClassName(['form-check'], ['c-increment-check'])
      }, React.createElement("input", {
        className: this.genClassName(['form-check-input'], ['c-increment-option']),
        type: "radio",
        id: this.genId(Mode.INCREMENT),
        value: Mode.INCREMENT,
        checked: this.state.year.selected === Mode.INCREMENT,
        disabled: this.isDisabled(),
        onChange: function onChange() {
          return _this3.setSelected(Mode.INCREMENT);
        }
      }), React.createElement("label", {
        className: this.genClassName(['form-check-label'], ['c-increment-option-label']),
        htmlFor: this.genId(Mode.INCREMENT)
      }, "Every")), React.createElement("select", {
        className: this.genClassName(['form-control', 'form-control-sm', 'mx-1'], ['c-increment-every']),
        disabled: this.isDisabled(Mode.INCREMENT),
        value: this.getValues(Mode.INCREMENT)[1],
        onChange: function onChange(e) {
          return _this3.setInValue(Mode.INCREMENT, 1, e.target.value);
        }
      }, this.state.yearCodes.map(function (item) {
        return React.createElement("option", {
          key: item.value,
          value: item.value
        }, item.value);
      })), React.createElement("label", {
        className: "c-increment-option-label2",
        htmlFor: this.genId(Mode.INCREMENT)
      }, "year(s) starting at year"), React.createElement("select", {
        className: this.genClassName(['form-control', 'form-control-sm', 'ml-1'], ['c-increment-from']),
        disabled: this.isDisabled(Mode.INCREMENT),
        value: this.getValues(Mode.INCREMENT)[0],
        onChange: function onChange(e) {
          return _this3.setInValue(Mode.INCREMENT, 0, e.target.value);
        }
      }, this.state.years.map(function (item) {
        return React.createElement("option", {
          key: item.value,
          value: item.value
        }, item.label);
      })));
    }
  }, {
    key: "genAnd",
    value: function genAnd() {
      var _this4 = this;

      return React.createElement("div", {
        className: this.genClassName(['form-group'], ['c-and'])
      }, React.createElement("div", {
        className: this.genClassName(['form-check'], ['c-and-check'])
      }, React.createElement("input", {
        className: this.genClassName(['form-check-input'], ['c-and-option']),
        type: "radio",
        id: this.genId(Mode.AND),
        value: Mode.AND,
        checked: this.state.year.selected === Mode.AND,
        disabled: this.isDisabled(),
        onChange: function onChange() {
          return _this4.setSelected(Mode.AND);
        }
      }), React.createElement("label", {
        className: this.genClassName(['form-check-label'], ['c-and-option-label']),
        htmlFor: this.genId(Mode.AND)
      }, "Specific year (choose one or many)")), React.createElement("div", {
        className: this.genClassName(['row', 'pl-3', 'pt-1'], ['c-and-list'])
      }, this.state.years.map(function (item) {
        return React.createElement("div", {
          className: _this4.genClassName(['col-1'], ['c-and-item']),
          "item-value": item.value,
          key: _this4.genId(Mode.AND, item.value)
        }, React.createElement("div", {
          className: _this4.genClassName(['form-check'], ['c-and-item-check'])
        }, React.createElement("input", {
          className: _this4.genClassName(['form-check-input'], ['c-and-item-field']),
          type: "checkbox",
          id: _this4.genId(Mode.AND, item.value),
          value: item.value,
          disabled: _this4.isDisabled(Mode.AND),
          checked: _this4.inSpecificsList(item.value, Mode.AND),
          onChange: function onChange() {
            return _this4.toggleSpecifics(item.value, Mode.AND);
          }
        }), React.createElement("label", {
          className: _this4.genClassName(['form-check-label'], ['c-and-item-label']),
          htmlFor: _this4.genId(Mode.AND, item.value)
        }, item.label)));
      })));
    }
  }, {
    key: "genRange",
    value: function genRange() {
      var _this5 = this;

      return React.createElement("div", {
        className: this.genClassName(['form-group', 'form-inline'], ['c-range'])
      }, React.createElement("div", {
        className: this.genClassName(['form-check'], ['c-range-check'])
      }, React.createElement("input", {
        className: this.genClassName(['form-check-input'], ['c-range-option']),
        type: "radio",
        id: this.genId(Mode.RANGE),
        value: Mode.RANGE,
        checked: this.state.year.selected === Mode.RANGE,
        disabled: this.isDisabled(),
        onChange: function onChange() {
          return _this5.setSelected(Mode.RANGE);
        }
      }), React.createElement("label", {
        className: this.genClassName(['form-check-label'], ['c-range-option-label']),
        htmlFor: this.genId(Mode.RANGE)
      }, "Every year between year")), React.createElement("select", {
        className: this.genClassName(['form-control', 'form-control-sm', 'mx-1'], ['c-range-from']),
        disabled: this.isDisabled(Mode.RANGE),
        value: this.getValues(Mode.RANGE)[0],
        onChange: function onChange(e) {
          return _this5.setInValue(Mode.RANGE, 0, e.target.value);
        }
      }, this.state.years.map(function (item) {
        return React.createElement("option", {
          key: item.value,
          value: item.value
        }, item.label);
      })), React.createElement("label", {
        className: "c-range-option-label2",
        htmlFor: this.genId(Mode.RANGE)
      }, "and year"), React.createElement("select", {
        className: this.genClassName(['form-control', 'form-control-sm', 'ml-1'], ['c-range-to']),
        disabled: this.isDisabled(Mode.RANGE),
        value: this.getValues(Mode.RANGE)[1],
        onChange: function onChange(e) {
          return _this5.setInValue(Mode.RANGE, 1, e.target.value);
        }
      }, this.state.years.map(function (item) {
        return React.createElement("option", {
          key: item.value,
          value: item.value
        }, item.label);
      })));
    }
  }]);

  return ReCronYear;
}(TabSingleSegmentComponent);

var tabs = [{
  label: 'Seconds',
  type: Type.SECONDS
}, {
  label: 'Minutes',
  type: Type.MINUTES
}, {
  label: 'Hours',
  type: Type.HOURS
}, {
  label: 'Day',
  type: Type.DAY
}, {
  label: 'Month',
  type: Type.MONTH
}, {
  label: 'Year',
  type: Type.YEAR
}];

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = ".c-tab-content {\n  outline: none;\n}";
styleInject(css);

var ReCron =
/*#__PURE__*/
function (_CronBaseComponent) {
  _inherits(ReCron, _CronBaseComponent);

  function ReCron(props) {
    var _this;

    _classCallCheck(this, ReCron);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ReCron).call(this, props, Date.now()));
    _this.state = {
      tab: tabs[0],
      session: _this.session
    };
    return _this;
  }

  _createClass(ReCron, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      QuartzCronDI.destroy(this.session);
    }
  }, {
    key: "render",
    value: function render() {
      this.getQuartzCron().fillFromExpression(this.props.value);
      return React.createElement("div", {
        className: "c-host"
      }, this.genTabs(), React.createElement("div", {
        className: "c-tab-content",
        role: "tabpanel",
        tabIndex: 0,
        "tab-name": this.state.tab.type
      }, this.genContent()));
    }
  }, {
    key: "genContent",
    value: function genContent() {
      var _this2 = this;

      var second = React.createElement(ReCronSecond, {
        session: this.state.session,
        cssClassPrefix: this.getCssClassPrefix(),
        disabled: this.props.disabled,
        onChange: function onChange() {
          return _this2.applyChanges();
        }
      });
      var minute = React.createElement(ReCronMinute, {
        session: this.state.session,
        cssClassPrefix: this.getCssClassPrefix(),
        disabled: this.props.disabled,
        onChange: function onChange() {
          return _this2.applyChanges();
        }
      });
      var hour = React.createElement(ReCronHour, {
        session: this.state.session,
        cssClassPrefix: this.getCssClassPrefix(),
        disabled: this.props.disabled,
        onChange: function onChange() {
          return _this2.applyChanges();
        }
      });
      var month = React.createElement(ReCronMonth, {
        session: this.state.session,
        cssClassPrefix: this.getCssClassPrefix(),
        disabled: this.props.disabled,
        onChange: function onChange() {
          return _this2.applyChanges();
        }
      });
      var year = React.createElement(ReCronYear, {
        session: this.state.session,
        cssClassPrefix: this.getCssClassPrefix(),
        disabled: this.props.disabled,
        onChange: function onChange() {
          return _this2.applyChanges();
        }
      });
      var day = React.createElement(ReCronDay, {
        session: this.state.session,
        cssClassPrefix: this.getCssClassPrefix(),
        disabled: this.props.disabled,
        onChange: function onChange() {
          return _this2.applyChanges();
        }
      });
      var map = new Map([[Type.SECONDS, second], [Type.MINUTES, minute], [Type.HOURS, hour], [Type.MONTH, month], [Type.YEAR, year], [Type.DAY, day]]);
      return map.get(this.state.tab.type);
    }
  }, {
    key: "genTabs",
    value: function genTabs() {
      var _this3 = this;

      var className = this.genClassName(['nav', 'nav-tabs', 'mb-2'], ['c-tabs']);
      return React.createElement("ul", {
        className: className,
        role: "tablist",
        "aria-label": "Cron Generator Tabs"
      }, tabs.map(function (t) {
        return _this3.genTab(t);
      }));
    }
  }, {
    key: "genTab",
    value: function genTab(item) {
      var _this4 = this;

      var isActive = this.state.tab === item;
      var className = this.genClassName(['nav-link'], [this.state.tab.type, 'c-tab', isActive ? 'active' : '']);
      return React.createElement("button", {
        key: item.type,
        role: "tab",
        type: "button",
        className: className,
        "aria-selected": isActive,
        tabIndex: isActive ? 0 : -1,
        onClick: function onClick() {
          return _this4.changeTab(item);
        }
      }, item.label);
    }
  }, {
    key: "applyChanges",
    value: function applyChanges() {
      var str = this.getQuartzCron().toString();

      if (this.props.onChange) {
        this.props.onChange(str);
      }
    }
  }, {
    key: "changeTab",
    value: function changeTab(item) {
      this.setState({
        tab: item
      });
    }
  }]);

  return ReCron;
}(CronBaseComponent);

export { ReCron };
